import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";

const MainLayout = () => (
  <div className="app-frame">
    <NavBar />
    <main className="content-area">
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default MainLayout;
